import {
	OnboardingLayout,
} from "@/components/layouts/OnboardingLayout"
import { PeriodSelector } from "@/components/forms/PeriodSelector"
import { RHFProvider } from "@/components/forms/RHFProvider"
import { useForm } from "react-hook-form"
import {
	PeriodFormData,
	PeriodFormDataOptionalRange,
} from "@/state/draft/period"

type OnboardingPeriodScreenProps = {
	onSubmit: (data: PeriodFormData) => void
	value: PeriodFormData
}

type FormData = PeriodFormDataOptionalRange

export function OnboardingPeriodScreen(props: OnboardingPeriodScreenProps) {
	const form = useForm<FormData>({
		defaultValues: props.value,
	})

	return (
		<OnboardingLayout
			stepper={{
				currentStep: 1,
				steps: 4,
			}}
			title="Reporting Period"
			onNext={async () => {
				form.handleSubmit((data) => {
					// TODO: fixed when form validation is fixed
					props.onSubmit(data as PeriodFormData)
				})()
			}}
		>
			<RHFProvider form={form}>
				<PeriodSelector {...props} form={form} />
			</RHFProvider>
		</OnboardingLayout>
	)
}
